import FeeList from '../../../../components/Purchasing/Order/Fee/FeeList'
import FeeModal from '../../../../components/Purchasing/Order/Fee/FeeModal'
import React, {Fragment} from 'react'

function Fee(props) {
  return (
    <Fragment>
      <FeeModal {...props} />
      <FeeList {...props} />
    </Fragment>
  )
}

export default Fee
